import { render, staticRenderFns } from "./RefundSuccess.vue?vue&type=template&id=3354e53a&scoped=true"
import script from "./RefundSuccess.vue?vue&type=script&lang=js"
export * from "./RefundSuccess.vue?vue&type=script&lang=js"
import style0 from "./RefundSuccess.vue?vue&type=style&index=0&id=3354e53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3354e53a",
  null
  
)

export default component.exports